module.exports = __webpack_public_path__ + "img/pyq_banner.54f3359f.png";